import { message } from "antd";
import React, { useEffect, useState } from "react";
import { Card, Form, FormGroup, Modal, ModalBody, Spinner } from "reactstrap";
import {
  Block,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  ManageBranchTable,
  PaginationComponent,
  RSelect,
} from "../../../components/Component";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";

import axios from "axios";
import { useForm } from "react-hook-form";
import { authHeader } from "../../../header";
import { statusOptions } from "../options_common";
import { useDebounce } from "../../../hooks/useDebounceSearch";
import { AllowAccess } from "../../../components/BlockAccess";

export const BranchManagement = () => {
  const [modal, setModal] = useState({
    edit: false,
    add: false,
    view: false,
  });
  const [editId, setEditedId] = useState();

  const [formData, setFormData] = useState({
    name: "",
    status: "",
    description: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(7);
  const [manageBranch, setManageBranch] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadBtn, setIsLoadBtn] = useState(false);
  const [, setDetails] = useState({});
  const [search, setSearch] = useState("");

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const debouncedSearchTerm = useDebounce(search, 500);

  useEffect(
    () => {
      // if (debouncedSearchTerm) {
      getAllBranches();
      setCurrentPage(1);
      // }v
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedSearchTerm] // Only call effect if debounced search term changes
  );

  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const resetForm = () => {
    setFormData({
      name: "",
      status: "",
      description: "",
    });
  };

  const onFormCancel = () => {
    setModal({ edit: false, add: false });
    resetForm();
  };

  const getAllBranches = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/admin/branches?search=${search}`, {
        headers: authHeader(),
      });
      const data = response.data;
      if (data) {
        setManageBranch(data);
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    }
  };

  const addManageBranch = async (obj) => {
    try {
      setIsLoadBtn(true);
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/admin/branches`, obj, {
        headers: authHeader(),
      });
      const formData = await response.data;
      if (formData) {
        getAllBranches();
        setIsLoadBtn(false);
        setIsLoading(false);
        setModal({ add: false });
        message.success({
          content: "Branch Created Successfully",
          style: {
            marginTop: "20vh",
          },
        });
        resetForm();
      }
      return { formData };
    } catch (error) {
      const message = error.response;
      setIsLoadBtn(false);
      setIsLoading(false);
      setModal({ add: false });
      message.error({
        content: message.data.message,
        style: {
          marginTop: "20vh",
        },
      });
      resetForm();
      return { message };
    }
  };

  const editManageBranch = async (obj) => {
    try {
      setIsLoadBtn(true);
      const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/auth/admin/branches/${editId}`, obj, {
        headers: authHeader(),
      });
      const formData = await response.data;
      if (formData) {
        getAllBranches();
        setIsLoadBtn(false);
        setIsLoading(false);
        setModal({ edit: false });
        message.success({
          content: "Branch Updated Successfully",
          style: {
            marginTop: "20vh",
          },
        });
        resetForm();
      }
      return { formData };
    } catch (error) {
      const message = error.response;
      setIsLoadBtn(false);
      setIsLoading(false);
      setModal({ edit: false });
      message.error({
        content: message.data.message,
        style: {
          marginTop: "20vh",
        },
      });
      resetForm();
      return { message };
    }
  };

  const onFormSubmit = () => {
    addManageBranch(formData);
    resetForm();
    setModal({ add: false });
  };

  const onEditSubmit = () => {
    editManageBranch(formData);
    resetForm();
    setModal({ edit: false });
  };

  const onEditClick = async (items) => {
    setModal({ edit: true });
    setFormData({
      name: items.name,
      status: items.status,
      description: items.description,
      id: items.id,
    });
    setDetails(items);
    setEditedId(items.id);
  };

  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = manageBranch?.slice(indexOfFirstItem, indexOfLastItem);

  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const { errors, register, handleSubmit } = useForm();

  useEffect(() => {
    getAllBranches();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <Head title="Branch Management"></Head>
      <Content>
        <Block size="lg">
          <BlockHead>
            <BlockHeadContent>
              <div className="d-flex justify-content-between align-items-center">
                <BlockTitle tag="h4">Manage Branch</BlockTitle>
                <div className="d-flex align-items-center justify-center">
                  <div className="mr-2">
                    <input
                      className="form-control"
                      value={search}
                      onChange={handleSearchChange}
                      placeholder="Search Branch..."
                    />
                  </div>
                  <AllowAccess allowedRights={["CREATE_BRANCH"]}>
                  <Button color="primary" onClick={() => setModal({ add: true })}>
                    <Icon name="plus"></Icon>
                    <span>Create Branch</span>
                  </Button></AllowAccess>
                </div>
              </div>
            </BlockHeadContent>
          </BlockHead>
          <Card className="card-bordered card-preview">
            {isLoading ? (
              <Spinner
                color="primary"
                style={{
                  height: "3rem",
                  width: "3rem",
                  margin: "0 auto",
                }}
              />
            ) : (
              <ManageBranchTable
                manageBranch={currentItems}
                modal={modal}
                onEditClick={onEditClick}
                handleView={() => setModal({ view: true })}
              />
            )}
          </Card>
          <div className="card-inner">
            {manageBranch && manageBranch.length > 0 ? (
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={manageBranch?.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">No branch found</span>
              </div>
            )}
          </div>
        </Block>

        <Modal isOpen={modal.add} toggle={() => setModal({ add: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Add Branch</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onFormSubmit)}>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Branch name</label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        placeholder="Branch"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Status</label>
                      <RSelect
                        options={statusOptions}
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                        onChange={(e) => setFormData({ ...formData, status: e.value })}
                      />
                      {errors.status && <span className="invalid">{errors.status.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col size="12">
                    <FormGroup>
                      <label className="form-label">Description</label>
                      <textarea
                        name="description"
                        // value={formData.description}
                        placeholder="Branch description"
                        onChange={(e) => onInputChange(e)}
                        className="form-control-xl form-control no-resize"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.description && <span className="invalid">{errors.description.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <Button color="primary" size="md" type="submit">
                          Submit
                        </Button>
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={modal.edit} toggle={() => setModal({ edit: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Edit Branch</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onEditSubmit)}>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Branch name</label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        placeholder="Branch"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Status</label>
                      <RSelect
                        value={statusOptions.find((d) => d.value === String(formData.status))}
                        options={statusOptions}
                        onChange={(e) => setFormData({ ...formData, status: e.value })}
                      />
                    </FormGroup>
                  </Col>
                  <Col size="12">
                    <FormGroup>
                      <label className="form-label">Description</label>
                      <textarea
                        name="description"
                        value={formData.description}
                        placeholder="Branch description"
                        onChange={(e) => onInputChange(e)}
                        className="form-control-xl form-control no-resize"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.description && <span className="invalid">{errors.description.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <Button color="primary" size="md" type="submit">
                          {isLoadBtn ? <Spinner size="sm" /> : "Submit"}
                        </Button>
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};
